import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '../../../SvgIcon';
import Modal from '../../../Modal';
import Link from '../../../Link';
import { profileTypes } from '../../../../lib/constants';
import { isRightToLeftDirection } from '../../../../util/utils';
import { ROUTES } from '../../../../lib/frontendRoutes';
import './BioModal.scss';
import withRouter from '../../../../util/withRouter';

const BioModal = ({
    t,
    onCloseBioModal,
    exitFullscreen,
    navigate,
    fullScreen,
    isBioModalInfo,
}) => {
    const baseClassName = 'pb-bio-modal';

    const learnMoreHandler = () => {
        if (fullScreen) {
            exitFullscreen();
        }
        navigate(
            isBioModalInfo?.role?.toLocaleLowerCase() ===
                profileTypes?.PUBLISHER
                ? ROUTES.PUBLISHER_PAGE?.replace(
                      ':slug',
                      isBioModalInfo?.learnMore
                  )
                : ROUTES?.CREDITS_PAGE?.replace(
                      ':slug',
                      isBioModalInfo?.learnMore
                  )
        );
    };
    return (
        <Modal onClose={onCloseBioModal} overflowContent noBoundsPadding>
            <div className={baseClassName}>
                <div className={`${baseClassName}__name`}>
                    {`${isBioModalInfo?.first_name ?? ''} ${
                        isBioModalInfo?.last_name ?? ''
                    }`}
                </div>
                {isBioModalInfo?.role && (
                    <div className={`${baseClassName}__role`}>
                        {`${isBioModalInfo?.role}`}
                    </div>
                )}
                <div className={`${baseClassName}__links-container`}>
                    {isBioModalInfo?.link && (
                        <Link href={isBioModalInfo?.link} shouldOpenNewPage>
                            <SvgIcon name="language_24dp" size={'2rem'} />
                        </Link>
                    )}
                    {isBioModalInfo?.email && (
                        <Link
                            href={`mailto:${isBioModalInfo?.email}`}
                            shouldOpenNewPage
                        >
                            <SvgIcon name="mail_24dp" size={'2rem'} />
                        </Link>
                    )}
                </div>
                {isBioModalInfo?.bio && (
                    <div
                        className={`${baseClassName}__bio ${
                            isRightToLeftDirection &&
                            `${baseClassName}__bio-left`
                        }`}
                    >
                        {`${isBioModalInfo?.bio}`}
                    </div>
                )}
                {isBioModalInfo?.learnMore && (
                    <div
                        className={`${baseClassName}__learnMore`}
                        onClick={learnMoreHandler}
                    >
                        {t('BioModal.learnMore')} {true ? <>&gt;</> : <>&lt;</>}
                    </div>
                )}
            </div>
        </Modal>
    );
};

BioModal.propTypes = {
    onCloseBioModal: PropTypes.func.isRequired,
    isBioModalInfo: PropTypes.shape({
        first_name: PropTypes.string.isRequired,
        last_name: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        bio: PropTypes.string,
    }).isRequired,
};

export default withRouter(BioModal);
